import { render, staticRenderFns } from "./ScadenzariListSwitcher.vue?vue&type=template&id=6c0485d0&"
import script from "./ScadenzariListSwitcher.vue?vue&type=script&lang=js&"
export * from "./ScadenzariListSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ScadenzariListSwitcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports